import React, { useCallback, useEffect, useState } from "react";
import { Flex, Text } from "@fluentui/react-northstar";
import { useTranslation } from "react-i18next";

import { useDeviceTesterStateContext } from "../../device-tester-context-provider/DeviceTesterContextProvider";
import { usePlatformTypeContext } from "../../platform-type-provider/PlatformTypeProvider";
import { DeviceStatus } from "../results-view/ResultsView.types";

import { ResultsHeader } from "./ResultsHeader";
import { useResultsHeaderStyles } from "./ResultsHeader.styles";
import { HeaderTypes } from "./ResultsHeader.types";

export const ConnectedResultsHeader: React.FC = () => {
  const { deviceTesterState } = useDeviceTesterStateContext();
  const [headerType, setHeaderType] = useState(HeaderTypes.NO_ISSUES);
  const { isMobile } = usePlatformTypeContext();
  const resultsHeaderStyles = useResultsHeaderStyles();
  const { t } = useTranslation();

  const getDeviceState = useCallback(() => {
    const errorStatus =
      deviceTesterState.microphoneResult.status !== DeviceStatus.WORKING ||
      deviceTesterState.speakerResult.status !== DeviceStatus.WORKING ||
      deviceTesterState.cameraResult.status !== DeviceStatus.WORKING ||
      deviceTesterState.networkResult.status !== DeviceStatus.WORKING;
    const errorDetected = errorStatus ? true : false;

    if (!deviceTesterState.isInfoFetched) {
      if (isMobile) {
        setHeaderType(HeaderTypes.FETCHING_DEVICE_INFO_MOBILE);
      } else {
        setHeaderType(HeaderTypes.FETCHING_DEVICE_INFO_DESKTOP);
      }
    } else if (errorDetected) {
      setHeaderType(HeaderTypes.MISSING_DEVICES);
    } else {
      setHeaderType(HeaderTypes.NO_ISSUES);
    }
  }, [
    deviceTesterState.microphoneResult.status,
    deviceTesterState.speakerResult.status,
    deviceTesterState.cameraResult.status,
    deviceTesterState.networkResult.status,
    deviceTesterState.isInfoFetched,
    isMobile,
  ]);

  useEffect(() => {
    getDeviceState();
  }, [getDeviceState]);

  if (isMobile) {
    return <ResultsHeader headerMessageType={headerType} />;
  } else {
    return (
      <Flex column hAlign="center" gap="gap.large">
        <Text
          content={<>{t("RESULTS_PAGE_HEADER_INFO_DESKTOP")}</>}
          styles={resultsHeaderStyles.resultsPageIndicator}
          align="center"
        />
        <Flex vAlign="end">
          <ResultsHeader headerMessageType={headerType} />
        </Flex>
      </Flex>
    );
  }
};
